module.exports = __webpack_public_path__ + "static/media/fotonower_.dca12421.png";